export default function highlightFromTo(text) {
    const regexFromTo = /from (.+?) to (.+)/;
    const matchFromTo = text.match(regexFromTo);

    if (matchFromTo) {
        const regex = /(from )(.+?)( to )(.+)/;
        const newFromValue = `<span style="color: #001B26;">${matchFromTo[1]}</span>`; // New “from” value
        const newToValue = `<span style="color: #001B26;">${matchFromTo[2]}</span>`; // New to value
        const updatedText = text.replace(regex, `$1${newFromValue}$3${newToValue}`);
        return updatedText;
    }

    const regexTo = /(?<=to\s).+$/;
    const matchTo = text.match(regexTo);

    if (matchTo) {
        const regex = /(to )(.+)/;
        const newToValue = `<span style="color: #001B26;">${matchTo[0]}</span>`; // New to value
        const updatedText = text.replace(regex, `$1${newToValue}`);
        return updatedText;
    }

    return text;
}
